import { GlobalStore } from '@roc/feature-app-core';
import { LenderLicensesBaseStore } from './lenderLicensesBaseStore';

export class LenderLicensesStore extends LenderLicensesBaseStore {
  constructor(globalStore: GlobalStore) {
    super(globalStore);
  }

  reset(): void {
    this.lenderLicensesGridStore.reset();
  }
}
